import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import { Drawer, Paper, Typography } from '@material-ui/core';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { getAccounts } from '../../actions/Accounts';
import { getSystems } from '../../actions/Systems';
import CommonButton from '../../components/atoms/CommonButton';
import ShashokuAdminSendMessageUserTable from '../organisms/ShashokuAdminSendMessageUserTable';
import {
  deleteMessageSentToUserByAdmin,
  getListMessageSentToUserByAdmin,
  addMessageAdminSendToUser,
  GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS,
  DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS,
  ADD_MESSAGE_ADMIN_SEND_TO_USER_SUCCESS
} from '../../actions/Users';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import AddMessageSendUserChooseSystemShashokuDialog from '../../components/molecules/AddMessageSendUserChooseSystemShashokuDialog';
import AddMessageSendUserWriteMessageShashokuDialog from '../../components/molecules/AddMessageSendUserWriteMessageShashokuDialog';
import ConfirmAddDialog from '../../components/molecules/ConfirmAddDialog';

const styles = {
  root: {},
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupRight: {
    textAlign: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      systems: state.systems.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getListMessageSentToUserByAdmin,
          getSystems,
          deleteMessageSentToUserByAdmin,
          addMessageAdminSendToUser
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('selectedTicketIds', 'setSelectedTicketIds', []),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('openDelete', 'setOpenDelete', false),
  withState('targetMessageId', 'setTargetMessageId', 0),
  withState('targetTitleMessage', 'setTargetTitleMessage', ''),
  withState('openAddChooseSystem', 'setOpenAddChooseSystem', false),
  withState('openAddWriteMessage', 'setOpenAddWriteMessage', false),
  withState('openConfirmAddMessage', 'setOpenConfirmAddMessage', false),
  withState('messageAdmin', 'setMessageAdmin', ''),
  withState('titleMessageAdmin', 'setTitletMessageAdmin', ''),
  withState('allSystem', 'setAllSystem', 1),
  withState('fromSystemIds', 'setFromSystemIds', []),
  withState('chooseSystemError', 'setChooseSystemError', ''),
  withState('titleMessageError', 'setTitleMessageError', ''),
  withState('messageError', 'setMessageError', ''),
  withHandlers({
    checkSession: props => data => {
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    handleChangePage: props => (e, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);
      const searchKey = {
        page,
        limit: limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions.getListMessageSentToUserByAdmin(searchKey).then(data => {
        props.checkSession(data);
        if (data.type === GET_LIST_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setErrorMessage('エラーが発生しました！');
          props.updateLoading(false);
          props.updateOpenProgress(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.actions.getSystems();
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    checkSession,
    classes,
    openDrawer,
    updateOpenDrawer,
    account,
    openTable,
    openProgress,
    updateOpenProgress,
    page,
    handleChangePage,
    loading,
    updateLoading,
    rowsPerPage,
    setRowsPerPage,
    resultMessage,
    setResultMessage,
    errorMessage,
    setErrorMessage,
    systems,
    openDelete,
    setOpenDelete,
    targetMessageId,
    setTargetMessageId,
    openAddChooseSystem,
    setOpenAddChooseSystem,
    openAddWriteMessage,
    setOpenAddWriteMessage,
    messageAdmin,
    setMessageAdmin,
    allSystem,
    setAllSystem,
    fromSystemIds,
    setFromSystemIds,
    chooseSystemError,
    setChooseSystemError,
    titleMessageAdmin,
    setTitletMessageAdmin,
    titleMessageError,
    setTitleMessageError,
    messageError,
    setMessageError,
    openConfirmAddMessage,
    setOpenConfirmAddMessage,
    targetTitleMessage,
    setTargetTitleMessage
  }) => {
    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };

    const openConfirmDelete = (id, title) => {
      setOpenDelete(true);
      setTargetMessageId(id);
      setTargetTitleMessage(title);
    };

    const handleDeleteMessage = async () => {
      updateOpenProgress(true);
      updateLoading(true);
      const response = await actions
        .deleteMessageSentToUserByAdmin(targetMessageId)
        .then(data => checkSession(data));
      if (response.type === DELETE_MESSAGE_SENT_TO_USER_BY_ADMIN_SUCCESS) {
        setResultMessage('削除を完了しました。');
      } else {
        updateOpenProgress(false);
        setErrorMessage('エラーが発生しました！');
      }
      setOpenDelete(false);
      updateLoading(false);
    };

    const handleOpenChooseSystem = () => {
      setAllSystem(1);
      setFromSystemIds([]);
      setOpenAddChooseSystem(true);
      setChooseSystemError('');
    };

    const handleOpenWriteMessage = () => {
      if (!allSystem && fromSystemIds.length === 0) {
        setChooseSystemError('必須項目です。');
        return;
      }
      setChooseSystemError('');
      setTitletMessageAdmin('');
      setMessageAdmin('');
      setTitleMessageError('');
      setMessageError('');
      setOpenAddWriteMessage(true);
      setOpenAddChooseSystem(false);
    };

    const handleCloseOpenWriteMessage = () => {
      setOpenAddWriteMessage(false);
      setOpenAddChooseSystem(true);
    };

    const validTitleMessage = () => {
      const value = titleMessageAdmin.trim();
      if (!value) {
        setTitleMessageError('必須項目です。');
        return 1;
      }
      setTitleMessageError('');
      return 0;
    };

    const validMessageBody = () => {
      const value = messageAdmin.trim();
      if (!value) {
        setMessageError('必須項目です。');
        return 1;
      }
      setMessageError('');
      return 0;
    };

    const valid = () => {
      const errorCount = validTitleMessage() + validMessageBody();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const handleAddAdminAddMessage = async () => {
      updateOpenProgress(true);
      updateLoading(true);
      const response = await actions
        .addMessageAdminSendToUser({
          fromSystemIds: allSystem === 1 ? [] : fromSystemIds,
          message: messageAdmin,
          allSystem,
          title: titleMessageAdmin
        })
        .then(data => checkSession(data));
      if (response.type === ADD_MESSAGE_ADMIN_SEND_TO_USER_SUCCESS) {
        setResultMessage('配信を完了しました。');
      } else {
        updateOpenProgress(false);
        setErrorMessage('エラーが発生しました！');
      }
      setOpenConfirmAddMessage(false);
      updateLoading(false);
    };

    const handleOpenConfirmAddMessage = () => {
      if (valid()) {
        setOpenAddWriteMessage(false);
        setOpenConfirmAddMessage(true);
      }
    };

    const handleCloseConfirmAddMessage = () => {
      setOpenAddWriteMessage(true);
      setOpenConfirmAddMessage(false);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            社食ごちめしのお知らせ
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div className={classes.buttonGroupRight}>
              <CommonButton
                title="お知らせ追加"
                secondary
                onClickAction={handleOpenChooseSystem}
              />
            </div>
          </div>
          {openTable && (
            <ShashokuAdminSendMessageUserTable
              page={page}
              handleChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              openConfirmDelete={openConfirmDelete}
            />
          )}
        </Paper>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />

        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={setOpenDelete}
          cancelAction={() => setOpenDelete(false)}
          deleteMessage={`「${targetTitleMessage}」のお知らせを削除してもよろしいですか？`}
          deleteAction={handleDeleteMessage}
        />

        <AddMessageSendUserChooseSystemShashokuDialog
          openChange={openAddChooseSystem}
          allSystem={allSystem}
          setAllSystem={setAllSystem}
          cancelAction={() => setOpenAddChooseSystem(false)}
          systems={systems}
          fromSystemIds={fromSystemIds}
          setFromSystemIds={setFromSystemIds}
          chooseSystemError={chooseSystemError}
          openConfirmAction={handleOpenWriteMessage}
        />

        <AddMessageSendUserWriteMessageShashokuDialog
          openChange={openAddWriteMessage}
          cancelAction={() => handleCloseOpenWriteMessage()}
          titleMessageAdmin={titleMessageAdmin}
          seTitletMessageAdmin={setTitletMessageAdmin}
          titleMessageError={titleMessageError}
          validTitleMessage={validTitleMessage}
          messageAdmin={messageAdmin}
          setMessageAdmin={setMessageAdmin}
          messageError={messageError}
          validMessageBody={validMessageBody}
          openConfirmAction={handleOpenConfirmAddMessage}
        />

        <ConfirmAddDialog
          openConfirm={openConfirmAddMessage}
          updateOpenConfirm={handleCloseConfirmAddMessage}
          okAction={handleAddAdminAddMessage}
          message="お知らせを配信してもよろしいですか？"
          btnText="配信する"
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
